var AdolopedEtdActions, AdolopmentDataActions, CERTAINTY_OF_EVIDENCE_CIRCLES, CERTAINTY_OF_EVIDENCE_CRITERIA, CERTAINTY_OF_EVIDENCE_TOTAL_CIRCLES, EtdActions, EtdVotingStore, HtmlExport, PLR_KEYS, PLR_PARTS_WITH_ADDITIONAL_FIELDS, QUESTION_VIEW_NAME_TO_PRINTOUT_TYPE, RECOMMENDATION_STRENGTHS_FROM_SELECTOR, W, alt, calculateTrustworthiness, convertFromRaw, convertMaybeDraftJsToPlainText, docSectionsUtils, draftRenderer, etdHeaderHelper, etdHelper, etdTemplatesSections, exportAgreeScore, exportAndSplitBySemicolon, exportAssessmentSummary, exportBooleanWithAdditionalOptions, exportCodeField, exportCodes, exportConclusions, exportFieldWithMissing, exportGuidelineFields, exportIsof, exportJustification, exportJustificationPromise, exportJustificationText, exportPlr, exportYesNoTextField, get, getAdditionalParts, getAssessmentSectionsPromises, getCertaintyOfEvidenceAndLabel, getCertaintyOfEvidenceCircles, getConclusionsContentPromise, getConsensusOrDraftField, getConsensusOrDraftMapEntry, getContentWithReferencesPromise, getEtdPrintout, getPlrRecommendationText, getQuestionIsofData, getQuestionSectionsContentPromise, getRecommendationConclusionsSectionId, getRecommendationDirectionAndStrength, getRecommendationHeaderData, getRecommendationMetadata, getRecommendationMetadataOrUndefined, getRecommendationQuestionType, getRecommendationText, getRecommendationTextContent, getRemarks, getRemarksContent, getRemarksText, getSimplifiedGradeCertaintyOfEvidence, getSofPrintout, gradeProCodeToWHOCode, mediator, plrBasePath, plrContentPath, prepareCodes, recommendationDirectionFallback, renderEditorValue, renderEditorValueFromRecommendationMetadata, renderRecommendationHeaderContentPromise, sanitizeHTML, _ref,
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

AdolopedEtdActions = require('actions/adoloped_etd_actions');

AdolopmentDataActions = require('actions/adolopment_data_actions');

alt = require('alt');

draftRenderer = require('lib/services/jsonld_exporter/draft_renderer');

EtdActions = require('actions/etd_actions');

etdHelper = require('lib/etd_helper');

etdHeaderHelper = require('lib/etd_header_helper');

etdTemplatesSections = require('lib/etd_templates/templates_sections');

EtdVotingStore = require('stores/etd_voting_store');

get = require('lodash').get;

_ref = require('lib/etd_helper'), getConsensusOrDraftField = _ref.getConsensusOrDraftField, getConsensusOrDraftMapEntry = _ref.getConsensusOrDraftMapEntry;

getQuestionIsofData = require('lib/questions_helper').getQuestionIsofData;

HtmlExport = require('lib/html_export');

mediator = require('mediator');

QUESTION_VIEW_NAME_TO_PRINTOUT_TYPE = require('lib/questions_helper').QUESTION_VIEW_NAME_TO_PRINTOUT_TYPE;

sanitizeHTML = require('base/lib/utils').sanitizeHTML;

docSectionsUtils = require('lib/services/document_sections_exporter/utils');

getContentWithReferencesPromise = docSectionsUtils.getContentWithReferencesPromise;

W = require('when/when');

convertFromRaw = Draft.convertFromRaw;

getRecommendationConclusionsSectionId = require('lib/recommendation_section_helper').getRecommendationConclusionsSectionId;

CERTAINTY_OF_EVIDENCE_TOTAL_CIRCLES = 4;

CERTAINTY_OF_EVIDENCE_CIRCLES = {
  'very_low': 1,
  'low': 2,
  'moderate': 3,
  'high': 4
};

gradeProCodeToWHOCode = function(_arg) {
  var codeType, name, value;
  codeType = _arg.codeType, value = _arg.value, name = _arg.name;
  return {
    'code': {
      '@type': codeType,
      'value': sanitizeHTML(value)
    },
    'name': sanitizeHTML(name)
  };
};

exportGuidelineFields = function(exportFunction, fields, fieldsMap, guidelineDoc) {
  return _.chain(fields).map(function(field) {
    return [field, exportFunction(guidelineDoc[field])];
  }).map(function(_arg) {
    var key, value;
    key = _arg[0], value = _arg[1];
    if (key in fieldsMap) {
      return [fieldsMap[key], value];
    } else {
      return [key, value];
    }
  }).object().value();
};

recommendationDirectionFallback = function(recommendationOption) {
  switch (recommendationOption) {
    case 'recommend_against':
    case 'suggest_against':
      return 'negative';
    case 'suggest_either':
      return 'none';
    case 'suggest':
    case 'recommend':
      return 'positive';
  }
};

renderEditorValue = function(value, attachments) {
  if (attachments == null) {
    attachments = {};
  }
  if (!Boolean(value)) {
    return '';
  }
  return draftRenderer.renderDraftJsContentToHTML(value, attachments);
};

exportJustificationText = function(recommendation, exportConsensusFields) {
  var attachments, content, details, detailsDescription, justification, overallContent, overallDescription, sectionsOrder, _ref1;
  if (exportConsensusFields == null) {
    exportConsensusFields = false;
  }
  attachments = get(recommendation, '_attachments', {});
  justification = get(recommendation, 'templateData.conclusions.sections.justification');
  if (!justification) {
    return void 0;
  }
  content = getConsensusOrDraftField(justification, 'content', exportConsensusFields);
  overallContent = renderEditorValue(content, attachments);
  if (!overallContent) {
    return void 0;
  }
  sectionsOrder = (_ref1 = get(recommendation, 'templateData.assessment.sectionsOrder')) != null ? _ref1 : [];
  details = _.reduce(sectionsOrder, function(acc, key) {
    var name, value;
    name = get(recommendation, "templateData.assessment.sections." + key + ".name");
    value = getConsensusOrDraftMapEntry(justification, 'details.criteria', key, exportConsensusFields);
    if (!value) {
      return acc;
    }
    return "" + acc + "<br /><br /><span style='font-style: italic'>" + name + "</span><br />" + value;
  }, '');
  if (!details) {
    return overallContent;
  }
  overallDescription = get(etdTemplatesSections(), 'conclusions.sections.justification.overallDescription');
  detailsDescription = get(etdTemplatesSections(), 'conclusions.sections.justification.details.description');
  return "<div> <span style='font-weight: bold'>" + overallDescription + "</span><br /> " + overallContent + " <br /><br /> <span style='font-weight: bold'>" + detailsDescription + "</span><br /> " + details + " </div>";
};

exportJustification = function(recommendation, exportConsensusFields) {
  var justificationText;
  if (exportConsensusFields == null) {
    exportConsensusFields = false;
  }
  justificationText = exportJustificationText(recommendation, exportConsensusFields);
  if (!justificationText) {
    return void 0;
  }
  return {
    content: justificationText
  };
};

exportConclusions = function(recommendation, sectionsToOmit, exportConsensusFields) {
  var attachments, sections, sectionsOrder, sectionsToReturn, _ref1;
  if (exportConsensusFields == null) {
    exportConsensusFields = false;
  }
  attachments = get(recommendation, '_attachments', {});
  sectionsOrder = (_ref1 = get(recommendation, 'templateData.conclusions.sectionsOrder')) != null ? _ref1 : [];
  sectionsOrder = _.reject(sectionsOrder, function(s) {
    return __indexOf.call(sectionsToOmit, s) >= 0 || __indexOf.call(etdHelper.getRecommendationTypeSections(), s) >= 0;
  });
  sectionsToReturn = _.reject(sectionsOrder, function(s) {
    return s === 'justification';
  });
  sections = _.chain(sectionsToReturn).map(function(sectionId) {
    var content, section, selectedOption;
    section = get(recommendation, "templateData.conclusions.sections." + sectionId);
    content = getConsensusOrDraftField(section, 'content', exportConsensusFields);
    content = renderEditorValue(content, attachments);
    if (!content) {
      content = void 0;
    }
    selectedOption = getConsensusOrDraftField(section, 'selectedOption', exportConsensusFields);
    if (!selectedOption) {
      selectedOption = void 0;
    }
    if (!(content || selectedOption)) {
      return null;
    }
    return [
      sectionId, {
        content: content,
        selectedOption: selectedOption
      }
    ];
  }).compact().object().value();
  return {
    sectionsOrder: sectionsOrder,
    sections: sections
  };
};

getConclusionsContentPromise = function(recommendation, sectionsToOmit) {
  var attachmentSource, attachments, sectionsOrder, sectionsToReturn, _ref1;
  attachments = get(recommendation, '_attachments', {});
  attachmentSource = {
    dbName: mediator.project.id,
    docId: recommendation != null ? recommendation._id : void 0
  };
  sectionsOrder = (_ref1 = get(recommendation, 'templateData.conclusions.sectionsOrder')) != null ? _ref1 : [];
  sectionsOrder = _.reject(sectionsOrder, function(s) {
    return __indexOf.call(sectionsToOmit, s) >= 0 || __indexOf.call(etdHelper.getRecommendationTypeSections(), s) >= 0;
  });
  sectionsToReturn = _.reject(sectionsOrder, function(s) {
    return s === 'justification';
  });
  return W.all(W.reduce(sectionsToReturn, function(acc, sectionId) {
    var content, contentConsensus, contentPromise, promise, section, selectedOption, selectedOptionConsensus;
    section = get(recommendation, "templateData.conclusions.sections." + sectionId);
    content = get(section, 'content');
    contentConsensus = get(section, 'contentConsensus', null);
    selectedOption = get(section, 'selectedOption');
    selectedOptionConsensus = get(section, 'selectedOptionConsensus', null);
    contentPromise = getContentWithReferencesPromise(sectionId, contentConsensus != null ? contentConsensus : content, '', attachments, attachmentSource);
    promise = contentPromise.then(function(result) {
      return {
        key: sectionId,
        content: result.htmlContent,
        referenceData: {
          references: result.references,
          referencesFromTables: result.referencesFromTables,
          fullReferencesData: result.fullReferencesData
        },
        selectedOption: selectedOptionConsensus != null ? selectedOptionConsensus : selectedOption
      };
    });
    acc.push(promise);
    return acc;
  }, [])).then(function(sections) {
    return {
      sectionsOrder: sectionsOrder,
      sections: _.chain(sections).map(function(_arg) {
        var content, key, referenceData, selectedOption;
        key = _arg.key, content = _arg.content, selectedOption = _arg.selectedOption, referenceData = _arg.referenceData;
        if (!(content || selectedOption)) {
          return null;
        }
        return [
          key, {
            content: content,
            selectedOption: selectedOption,
            referenceData: referenceData
          }
        ];
      }).compact().object().value()
    };
  });
};

exportAssessmentSummary = function(recommendation) {
  var sections, sectionsOrder, _ref1;
  sectionsOrder = (_ref1 = get(recommendation, 'templateData.assessment.sectionsOrder')) != null ? _ref1 : [];
  sections = _.chain(sectionsOrder).map(function(key) {
    var acId, additionalConsiderations, criterionId, reId, researchEvidences, value;
    criterionId = get(recommendation, "templateData.assessment.sections." + key + ".criterionId");
    reId = get(recommendation, "templateData.assessment.sections." + key + ".researchEvidenceId");
    acId = get(recommendation, "templateData.assessment.sections." + key + ".additionalConsiderationId");
    if (!criterionId) {
      return null;
    }
    value = get(recommendation, "templateData.assessment.criteria." + criterionId + ".selectedOption");
    researchEvidences = get(recommendation, "templateData.assessment.researchEvidences." + reId + ".content", '');
    additionalConsiderations = get(recommendation, "templateData.assessment.additionalConsiderations." + acId + ".content", '');
    if (((value == null) || value === '') && ((researchEvidences == null) || researchEvidences === '') && ((additionalConsiderations == null) || additionalConsiderations === '')) {
      return null;
    }
    return [
      key, {
        value: value,
        researchEvidences: researchEvidences,
        additionalConsiderations: additionalConsiderations
      }
    ];
  }).compact().object().value();
  if (!sections) {
    return void 0;
  }
  return {
    sections: sections,
    sectionsOrder: sectionsOrder
  };
};

getAssessmentSectionsPromises = function(recommendation) {
  var attachmentSource, attachments, sectionsOrder, _ref1;
  attachments = get(recommendation, '_attachments', {});
  attachmentSource = {
    dbName: mediator.project.id,
    docId: recommendation != null ? recommendation._id : void 0
  };
  sectionsOrder = (_ref1 = get(recommendation, 'templateData.assessment.sectionsOrder')) != null ? _ref1 : [];
  return W.all(W.reduce(sectionsOrder, function(acc, key) {
    var acId, acPromise, additionalConsiderations, additionalConsiderationsConsensus, criterionId, reId, rePromise, researchEvidenceConsensus, researchEvidences, sectionPromise, value, valueConsensus;
    criterionId = get(recommendation, "templateData.assessment.sections." + key + ".criterionId");
    reId = get(recommendation, "templateData.assessment.sections." + key + ".researchEvidenceId");
    acId = get(recommendation, "templateData.assessment.sections." + key + ".additionalConsiderationId");
    if (!criterionId) {
      return acc;
    }
    value = get(recommendation, "templateData.assessment.criteria." + criterionId + ".selectedOption");
    valueConsensus = get(recommendation, "templateData.assessment.criteria." + criterionId + ".selectedOptionConsensus", null);
    researchEvidences = get(recommendation, "templateData.assessment.researchEvidences." + reId + ".content", '');
    researchEvidenceConsensus = get(recommendation, "templateData.assessment.researchEvidences." + reId + ".contentConsensus", null);
    additionalConsiderations = get(recommendation, "templateData.assessment.additionalConsiderations." + acId + ".content", '');
    additionalConsiderationsConsensus = get(recommendation, "templateData.assessment.additionalConsiderations." + acId + ".contentConsensus", null);
    rePromise = getContentWithReferencesPromise(reId, researchEvidenceConsensus != null ? researchEvidenceConsensus : researchEvidences, '', attachments, attachmentSource);
    acPromise = getContentWithReferencesPromise(acId, additionalConsiderationsConsensus != null ? additionalConsiderationsConsensus : additionalConsiderations, '', attachments, attachmentSource);
    sectionPromise = W.all([rePromise, acPromise]).then(function(_arg) {
      var acResult, reResult;
      reResult = _arg[0], acResult = _arg[1];
      return {
        key: key,
        value: valueConsensus != null ? valueConsensus : value,
        researchEvidences: reResult.htmlContent,
        additionalConsiderations: acResult.htmlContent,
        reReferences: _.omit(reResult, 'htmlContent'),
        acReferences: _.omit(acResult, 'htmlContent')
      };
    });
    acc.push(sectionPromise);
    return acc;
  }, [])).then(function(sections) {
    return {
      sectionsOrder: sectionsOrder,
      sections: _.chain(sections).map(function(_arg) {
        var acReferences, additionalConsiderations, key, reReferences, researchEvidences, value;
        key = _arg.key, value = _arg.value, researchEvidences = _arg.researchEvidences, additionalConsiderations = _arg.additionalConsiderations, reReferences = _arg.reReferences, acReferences = _arg.acReferences;
        if (!(value || researchEvidences || additionalConsiderations)) {
          return null;
        }
        return [
          key, {
            value: value,
            researchEvidences: researchEvidences || '',
            additionalConsiderations: additionalConsiderations || '',
            referenceData: {
              references: reReferences.references.concat(acReferences.references),
              referencesFromTables: reReferences.referencesFromTables.concat(acReferences.referencesFromTables),
              fullReferencesData: reReferences.fullReferencesData.concat(acReferences.fullReferencesData)
            }
          }
        ];
      }).compact().object().value()
    };
  });
};

exportJustificationPromise = function(recommendation) {
  var attachmentSource, attachments, content, contentConsensus, contentPromise, justification, sectionsOrder, _ref1;
  attachments = get(recommendation, '_attachments', {});
  attachmentSource = {
    dbName: mediator.project.id,
    docId: recommendation != null ? recommendation._id : void 0
  };
  justification = get(recommendation, 'templateData.conclusions.sections.justification');
  if (!justification) {
    return W.resolve();
  }
  content = get(justification, 'content');
  contentConsensus = get(justification, 'contentConsensus', null);
  contentPromise = getContentWithReferencesPromise('justification', contentConsensus != null ? contentConsensus : content, '', attachments, attachmentSource);
  sectionsOrder = (_ref1 = get(recommendation, 'templateData.assessment.sectionsOrder')) != null ? _ref1 : [];
  return contentPromise.then(function(result) {
    var details, detailsDescription, overallContent, overallDescription, referenceData;
    if (!result.htmlContent) {
      return void 0;
    }
    referenceData = {
      references: result.references,
      referencesFromTables: result.referencesFromTables,
      fullReferencesData: result.fullReferencesData
    };
    overallContent = result.htmlContent;
    details = _.reduce(sectionsOrder, function(acc, key) {
      var name, value;
      name = get(recommendation, "templateData.assessment.sections." + key + ".name");
      value = get(justification, "details.criteria." + key);
      if (!value) {
        return acc;
      }
      return "" + acc + "<br /><span style='font-style: italic'>" + name + "</span><br />" + value;
    }, '');
    if (!details) {
      return {
        content: overallContent,
        referenceData: referenceData
      };
    }
    overallDescription = get(etdTemplatesSections(), 'conclusions.sections.justification.overallDescription');
    detailsDescription = get(etdTemplatesSections(), 'conclusions.sections.justification.details.description');
    return {
      content: "<div> <span style='font-weight: bold'>" + overallDescription + "</span><br /> " + overallContent + " <br /> <span style='font-weight: bold'>" + detailsDescription + "</span><br /> " + details + " </div>",
      referenceData: referenceData
    };
  });
};

getQuestionSectionsContentPromise = function(recommendation) {
  var attachmentSource, attachments, sectionsData, sectionsOrder, _ref1, _ref2;
  attachments = get(recommendation, '_attachments', {});
  attachmentSource = {
    dbName: mediator.project.id,
    docId: recommendation != null ? recommendation._id : void 0
  };
  sectionsOrder = (_ref1 = get(recommendation, 'templateData.question.sectionsOrder')) != null ? _ref1 : [];
  sectionsData = (_ref2 = get(recommendation, 'templateData.question.sections')) != null ? _ref2 : {};
  return W.all(W.reduce(sectionsOrder, function(acc, sectionId) {
    var content, contentPromise, promise;
    if (__indexOf.call(_.keys(sectionsData), sectionId) < 0) {
      return acc;
    }
    content = get(recommendation, "templateData.question.sections." + sectionId + ".content");
    contentPromise = getContentWithReferencesPromise(sectionId, content, '', attachments, attachmentSource);
    promise = contentPromise.then(function(content) {
      var _ref3;
      return {
        key: sectionId,
        content: (_ref3 = content.htmlContent) != null ? _ref3 : '',
        referenceData: content.fullReferencesData
      };
    });
    acc.push(promise);
    return acc;
  }, [])).then(function(sections) {
    return {
      sectionsOrder: _.filter(sectionsOrder, function(sectionId) {
        return __indexOf.call(_.keys(sectionsData), sectionId) >= 0;
      }),
      sections: _.chain(sections).map(function(_arg) {
        var content, key, referenceData;
        key = _arg.key, content = _arg.content, referenceData = _arg.referenceData;
        if (!content) {
          return null;
        }
        return [
          key, {
            content: content,
            referenceData: referenceData
          }
        ];
      }).compact().object().value()
    };
  });
};

getRecommendationQuestionType = function(question) {
  var questionType;
  questionType = (question != null ? question.get : void 0) != null ? question.get('type') : get(question, 'type');
  if (questionType === 'diagnostic') {
    return 'dx';
  } else {
    return 'tx';
  }
};

renderRecommendationHeaderContentPromise = function(recommendation, sectionId, content, isRichField) {
  var attachmentSource, attachments, _ref1;
  if (content == null) {
    return W.resolve('');
  }
  if (_.isString(content)) {
    return W.resolve(content);
  }
  if (docSectionsUtils.isEmptyNonStringContent(content)) {
    return W.resolve('');
  }
  if (!isRichField) {
    return W.resolve('');
  }
  attachments = get(recommendation, '_attachments', {});
  attachmentSource = {
    dbName: (_ref1 = mediator.project) != null ? _ref1.id : void 0,
    docId: recommendation != null ? recommendation._id : void 0
  };
  return docSectionsUtils.getContentWithReferencesPromise("header-" + sectionId, content, '', attachments, attachmentSource).then(function(_arg) {
    var htmlContent;
    htmlContent = _arg.htmlContent;
    return htmlContent != null ? htmlContent : '';
  });
};

getRecommendationHeaderData = function(recommendation, question) {
  var headerFields, headerSections, questionData, questionHeaderFields, questionType, _ref1, _ref2;
  questionData = (question != null ? question.get : void 0) != null ? question : Immutable.fromJS(question != null ? question : {});
  headerSections = (_ref1 = get(recommendation, 'templateData.question.sections')) != null ? _ref1 : {};
  headerFields = get(recommendation, 'templateData.question.sectionsOrder');
  if (headerFields == null) {
    headerFields = _.pluck((_ref2 = get(recommendation, 'templateDef.question')) != null ? _ref2 : [], 'id');
  }
  questionType = getRecommendationQuestionType(question);
  headerFields = _.filter(headerFields, function(sectionId) {
    return __indexOf.call(_.keys(headerSections), sectionId) >= 0;
  });
  questionHeaderFields = _.filter(['author', 'background'], function(sectionId) {
    var content;
    if (__indexOf.call(headerFields, sectionId) >= 0) {
      return false;
    }
    content = etdHeaderHelper.getQuestionAttrContent({
      question: questionData,
      questionType: questionType,
      sectionId: sectionId,
      type: 'regular'
    });
    return !_.isEmpty(content);
  });
  headerFields = _.union(headerFields, questionHeaderFields);
  return W.all(_.map(headerFields, function(sectionId) {
    var content, isInAutoMode, isRichField;
    if (sectionId === 'comparison' && etdHeaderHelper.isDxQuestionWithoutComparatorTest({
      question: questionData,
      questionType: questionType
    })) {
      return W.resolve(null);
    }
    isInAutoMode = etdHeaderHelper.hasAutoContentGenerationOn({
      headerSections: headerSections,
      sectionId: sectionId,
      type: 'regular'
    });
    content = isInAutoMode ? etdHeaderHelper.getQuestionAttrContent({
      question: questionData,
      questionType: questionType,
      sectionId: sectionId,
      type: 'regular'
    }) : get(recommendation, "templateData.question.sections." + sectionId + ".content");
    if (_.isEmpty(content) && (sectionId === 'author' || sectionId === 'background')) {
      content = etdHeaderHelper.getQuestionAttrContent({
        question: questionData,
        questionType: questionType,
        sectionId: sectionId,
        type: 'regular'
      });
    }
    isRichField = __indexOf.call(etdHeaderHelper.RICH_FORMAT_FIELDS, sectionId) >= 0;
    return renderRecommendationHeaderContentPromise(recommendation, sectionId, content, isRichField).then(function(renderedContent) {
      if (_.isEmpty(renderedContent)) {
        return null;
      }
      return [sectionId, renderedContent];
    });
  })).then(function(pairs) {
    return _.object(_.compact(pairs));
  });
};

exportFieldWithMissing = function(value) {
  if (value == null) {
    return void 0;
  }
  if (value === 'missing') {
    return void 0;
  }
  return value;
};

RECOMMENDATION_STRENGTHS_FROM_SELECTOR = {
  'recommend_against': ['negative', 'strong'],
  'suggest_against': ['negative', 'weak'],
  'suggest_either': ['none', 'weak'],
  'suggest': ['positive', 'weak'],
  'recommend': ['positive', 'strong']
};

getRecommendationMetadata = function(recommendation, key, defaultValue) {
  var _ref1;
  if (defaultValue == null) {
    defaultValue = [];
  }
  return [].concat((_ref1 = get(recommendation, "templateData.conclusions.sections.recommendation." + key)) != null ? _ref1 : defaultValue);
};

getRecommendationMetadataOrUndefined = function(recommendation, key) {
  var value;
  value = getRecommendationMetadata(recommendation, key);
  if (_.isEmpty(value)) {
    return void 0;
  }
  value = value[0];
  if (value == null) {
    return void 0;
  }
  return value;
};

renderEditorValueFromRecommendationMetadata = function(recommendation, key) {
  var value;
  value = getRecommendationMetadataOrUndefined(recommendation, key);
  if (!value) {
    return void 0;
  }
  return renderEditorValue(value, get(recommendation, '_attachments', {}));
};

getRecommendationDirectionAndStrength = function(recommendation, exportConsensusFields) {
  var additionalRecommendationOptions, conclusionsInTemplate, recommendationDirection, recommendationOption, recommendationOptionValue, recommendationOptions, recommendationStrength, recommendationTypeDef, recommendationTypeId, sectionPath, _ref1;
  if (exportConsensusFields == null) {
    exportConsensusFields = false;
  }
  recommendationStrength = exportFieldWithMissing(getRecommendationMetadata(recommendation, 'strengthOfRecommendation')[0]);
  if (recommendationStrength != null) {
    if (recommendationStrength in RECOMMENDATION_STRENGTHS_FROM_SELECTOR) {
      return RECOMMENDATION_STRENGTHS_FROM_SELECTOR[recommendationStrength];
    }
    return ['none', recommendationStrength];
  }
  conclusionsInTemplate = (_ref1 = recommendation != null ? recommendation['templateDef']['conclusions'] : void 0) != null ? _ref1 : [];
  recommendationTypeDef = _.find(conclusionsInTemplate, function(_arg) {
    var checked, id, required;
    id = _arg.id, checked = _arg.checked, required = _arg.required;
    return (Boolean(checked) || Boolean(required)) && __indexOf.call(etdHelper.getRecommendationTypeSections(), id) >= 0;
  });
  if (!recommendationTypeDef) {
    return [void 0, void 0, void 0];
  }
  recommendationTypeId = recommendationTypeDef.id;
  sectionPath = "templateData.conclusions.sections." + recommendationTypeId;
  recommendationOptionValue = getConsensusOrDraftField(get(recommendation, sectionPath), 'selectedOption', exportConsensusFields);
  recommendationOptions = get(recommendation, "templateData.conclusions.sections." + recommendationTypeId + ".options");
  additionalRecommendationOptions = get(recommendation, "templateData.conclusions.sections." + recommendationTypeId + ".customOptions");
  recommendationOption = _.find(recommendationOptions.concat(additionalRecommendationOptions || []), function(_arg) {
    var value;
    value = _arg.value;
    return value === recommendationOptionValue;
  });
  if (!recommendationOption) {
    return [void 0, void 0, void 0];
  }
  recommendationDirection = get(recommendationOption, 'direction', recommendationDirectionFallback(recommendationOption != null ? recommendationOption.value : void 0));
  recommendationStrength = recommendationOptionValue.indexOf('recommend') >= 0 ? 'strong' : 'weak';
  return [recommendationDirection, recommendationStrength, recommendationOption];
};

CERTAINTY_OF_EVIDENCE_CRITERIA = ['certaintyOfEvidence', 'certaintyOfEvidenceOfTestAccuracy'];

getCertaintyOfEvidenceAndLabel = function(recommendation, exportConsensusFields) {
  var certaintyOfEvidence, getCriterionSelectedOption, gradeCertaintyOfEvidenceLabel;
  if (exportConsensusFields == null) {
    exportConsensusFields = false;
  }
  certaintyOfEvidence = exportFieldWithMissing(getRecommendationMetadata(recommendation, 'certaintyOfEvidence')[0]);
  if (certaintyOfEvidence != null) {
    return [certaintyOfEvidence, 'certainty_of_evidence'];
  }
  getCriterionSelectedOption = function(criterion) {
    return getConsensusOrDraftField(get(recommendation, "templateData.assessment.criteria." + criterion), 'selectedOption', exportConsensusFields);
  };
  certaintyOfEvidence = _.chain(CERTAINTY_OF_EVIDENCE_CRITERIA).map(getCriterionSelectedOption).find(function(val) {
    return Boolean(val);
  }).value();
  gradeCertaintyOfEvidenceLabel = certaintyOfEvidence != null ? 'certainty_of_evidence' : void 0;
  return [certaintyOfEvidence, gradeCertaintyOfEvidenceLabel];
};

getSimplifiedGradeCertaintyOfEvidence = function(certaintyOfEvidence) {
  switch (certaintyOfEvidence) {
    case 'very_low':
    case 'very_low_to_low':
      return 'very_low';
    case 'low':
    case 'low_to_moderate':
      return 'low';
    case 'moderate':
    case 'moderate_to_high':
      return 'high';
    case 'high':
      return 'high';
    default:
      return void 0;
  }
};

getEtdPrintout = function(projectId, questionModel, recommendationId) {
  return W.promise(function(resolve, reject) {
    var actions, actionsToStoresMap, callbackId, exportAfterDataIsFetched, hasAdolopment, isFetchingInStores, recommendationAdolopmentIds;
    exportAfterDataIsFetched = function() {
      var htmlExport, options;
      options = EtdVotingStore.getVotingData().isEmpty() ? {} : {
        etdViewMode: 'judgements-consensus#recommendation-consensus#conclusions-proposed',
        showVotingResults: false
      };
      htmlExport = new HtmlExport(questionModel, 'recommendations-v2', options);
      return htmlExport.getSource()["finally"](function() {
        return alt.recycle('EtdStore', 'AdolopedEtdStore', 'QuestionsStore', 'EtdVotingStore', 'ReferencesStore', 'OverarchingQuestionsStore', 'PanelVoiceStore', 'PanelVoiceEtdStore');
      }).then(resolve, reject);
    };
    recommendationAdolopmentIds = questionModel.get('recommendationAdolopmentIds');
    hasAdolopment = !_.isEmpty(recommendationAdolopmentIds);
    isFetchingInStores = {
      etd: true,
      questions: true,
      voting: true,
      references: true,
      adolopmentData: hasAdolopment,
      adolopmentEtd: hasAdolopment
    };
    actionsToStoresMap = {
      'EtdActions.fetchSuccess': 'etd',
      'EtdActions.fetchError': 'etd',
      'ReferencesActions.fetchSuccess': 'references',
      'ReferencesActions.fetchError': 'references',
      'EtdVotingActions.fetchSuccess': 'voting',
      'EtdVotingActions.fetchError': 'voting',
      'QuestionsActions.fetchSuccess': 'questions',
      'QuestionsActions.fetchError': 'questions',
      'AdolopedEtdActions.fetchSuccess': 'adolopmentEtd',
      'AdolopedEtdActions.fetchError': 'adolopmentEtd',
      'AdolopmentDataActions.fetchAdolopmentDataSuccess': 'adolopmentData',
      'AdolopmentDataActions.fetchAdolopmentDataError': 'adolopmentData'
    };
    actions = _(actionsToStoresMap).keys();
    callbackId = alt.dispatcher.register(function(payload) {
      var _ref1;
      if (_ref1 = payload.action, __indexOf.call(actions, _ref1) < 0) {
        return;
      }
      isFetchingInStores[actionsToStoresMap[payload.action]] = false;
      if (_.any(_(isFetchingInStores).values())) {
        return;
      }
      alt.dispatcher.unregister(callbackId);
      return setTimeout(exportAfterDataIsFetched, 100);
    });
    EtdActions.fetch({
      dbId: projectId,
      docId: [recommendationId]
    });
    if (hasAdolopment) {
      AdolopedEtdActions.fetch({
        dbId: projectId,
        docIds: recommendationAdolopmentIds
      });
      return AdolopmentDataActions.fetchAdolopmentData(projectId);
    }
  });
};

getSofPrintout = function(questionModel) {
  var hasIDSAFeaturesSwitch, htmlExport, printoutType, viewName;
  hasIDSAFeaturesSwitch = mediator.services.switches.isOn('idsaFeatures');
  viewName = questionModel.isDiagnostic() ? hasIDSAFeaturesSwitch ? 'LayerTwoSof' : 'LayerOneSof' : hasIDSAFeaturesSwitch ? 'SOF_v4' : 'SOF';
  printoutType = QUESTION_VIEW_NAME_TO_PRINTOUT_TYPE[viewName];
  htmlExport = new HtmlExport(questionModel, printoutType, {});
  return htmlExport.getSource('landscape', {}, viewName);
};

exportIsof = function(questionModel, projectName) {
  return getQuestionIsofData(questionModel, projectName);
};

getRecommendationTextContent = function(recommendation, isGps, exportConsensusFields) {
  var section, sectionId, _ref1;
  if (isGps == null) {
    isGps = false;
  }
  if (exportConsensusFields == null) {
    exportConsensusFields = false;
  }
  sectionId = getRecommendationConclusionsSectionId(recommendation, isGps);
  section = get(recommendation, "templateData.conclusions.sections." + sectionId);
  return (_ref1 = getConsensusOrDraftField(section, 'content', exportConsensusFields)) != null ? _ref1 : '';
};

getRecommendationText = function(recommendation, isGps, exportConsensusFields) {
  if (isGps == null) {
    isGps = false;
  }
  if (exportConsensusFields == null) {
    exportConsensusFields = false;
  }
  return renderEditorValue(getRecommendationTextContent(recommendation, isGps, exportConsensusFields), get(recommendation, '_attachments', {}));
};

getRemarksContent = function(recommendation) {
  var sectionId;
  sectionId = _.some(get(recommendation, 'templateDef.conclusions'), function(_arg) {
    var id;
    id = _arg.id;
    return id === 'decision';
  }) ? 'decision' : 'recommendation';
  return get(recommendation, "templateData.conclusions.sections." + sectionId + ".remarks.content", '');
};

getRemarks = function(recommendation) {
  return renderEditorValue(getRemarksContent(recommendation), get(recommendation, '_attachments', {}));
};

getRemarksText = function(recommendation, isGps) {
  var sectionId;
  if (isGps == null) {
    isGps = false;
  }
  sectionId = isGps ? 'goodPracticeStatement' : _.some(get(recommendation, 'templateDef.conclusions'), function(_arg) {
    var id;
    id = _arg.id;
    return id === 'decision';
  }) ? 'decision' : 'recommendation';
  return renderEditorValue(get(recommendation, "templateData.conclusions.sections." + sectionId + ".remarks.content"), get(recommendation, '_attachments', {}));
};

getCertaintyOfEvidenceCircles = function(question, recommendation) {
  var certaintyNumericValue, certaintySelectedOption, circles, criterion, isDiagnostic, label, option, options, sectionName, _ref1, _ref2;
  if (!question || !recommendation) {
    return null;
  }
  isDiagnostic = question.get('type') === 'diagnostic';
  sectionName = isDiagnostic ? 'certaintyOfEffects' : 'certaintyOfEvidence';
  criterion = recommendation.getIn(['templateData', 'assessment', 'criteria', sectionName]);
  certaintySelectedOption = criterion != null ? criterion.get('selectedOption') : void 0;
  options = (_ref1 = criterion != null ? criterion.get('options') : void 0) != null ? _ref1 : Immutable.List();
  label = certaintySelectedOption != null ? (option = options.find(function(option) {
    return option.get('value') === certaintySelectedOption;
  }), option != null ? option.get('text') : void 0) : null;
  certaintyNumericValue = (_ref2 = CERTAINTY_OF_EVIDENCE_CIRCLES[certaintySelectedOption]) != null ? _ref2 : 0;
  circles = Array(CERTAINTY_OF_EVIDENCE_TOTAL_CIRCLES).fill('').map(function(_elem, idx) {
    if (idx < certaintyNumericValue) {
      return "⨁";
    } else {
      return "◯";
    }
  });
  return {
    label: label,
    circles: circles
  };
};

convertMaybeDraftJsToPlainText = function(value) {
  if (value == null) {
    return '';
  }
  if (_.isString(value)) {
    return value;
  }
  return convertFromRaw(value).getPlainText();
};

exportYesNoTextField = function(value) {
  var plainText, showTextInput, text;
  if (value == null) {
    return void 0;
  }
  showTextInput = value.showTextInput, text = value.text;
  plainText = convertMaybeDraftJsToPlainText(text);
  if (plainText === 'notReported') {
    return plainText;
  }
  if (showTextInput) {
    if (_.isString(text)) {
      return text;
    } else {
      return renderEditorValue(text);
    }
  } else {
    return 'no';
  }
};

exportBooleanWithAdditionalOptions = function(value) {
  if (value == null) {
    return void 0;
  }
  return value.toString();
};

exportAgreeScore = function(guidelineDoc) {
  var _ref1;
  return {
    'applicability': get(guidelineDoc, 'applicability'),
    'clarityOfPresentation': get(guidelineDoc, 'clarityOfPresentation'),
    'editorialIndependence': get(guidelineDoc, 'editorialIndependence'),
    'editorialProcess': get(guidelineDoc, 'editorialProcess'),
    'rigorOfDevelopment': get(guidelineDoc, 'rigorOfDevelopment'),
    'scopeAndPurpose': get(guidelineDoc, 'scopeAndPurpose'),
    'scorePassed': (_ref1 = get(guidelineDoc, 'scorePassed')) != null ? _ref1 : false,
    'stakeholderInvolvement': get(guidelineDoc, 'stakeholderInvolvement')
  };
};

calculateTrustworthiness = function(agreeScore, fields) {
  var minScore;
  if (_.isEmpty(agreeScore) || _.some(fields, function(field) {
    return agreeScore[field] === null || !_.isNumber(agreeScore[field]) || isNaN(agreeScore[field]);
  })) {
    return void 0;
  }
  minScore = _.chain(agreeScore).pick(fields).values().min().value();
  if (minScore >= 80) {
    return 'high';
  } else if (minScore >= 70) {
    return 'moderate';
  } else if (minScore >= 60) {
    return 'basic';
  } else {
    return 'archived';
  }
};

exportCodeField = function(fieldValue) {
  if (_.isEmpty(fieldValue)) {
    return [];
  }
  return _.map(fieldValue, function(_arg) {
    var codes, codesRaw, id, value;
    id = _arg.id, value = _arg.value, codesRaw = _arg.codes;
    codes = _.chain(codesRaw).values().map(gradeProCodeToWHOCode).value();
    return {
      '@id': id,
      'name': value,
      'codes': codes
    };
  });
};

exportAndSplitBySemicolon = function(fieldValue) {
  if (_.isEmpty(fieldValue)) {
    return [];
  }
  return _.map(fieldValue.split(';'), function(value) {
    return value.trim();
  });
};

prepareCodes = function(codes) {
  return _.chain(codes).values().map(gradeProCodeToWHOCode).value();
};

exportCodes = function(fieldValue) {
  if (_.isEmpty(fieldValue)) {
    return [];
  }
  return _.compact(_.map(fieldValue, function(_arg) {
    var codesRaw, id, selected, value;
    id = _arg.id, value = _arg.value, selected = _arg.selected, codesRaw = _arg.codes;
    if (!selected) {
      return;
    }
    return {
      '@id': id,
      'name': value,
      'codes': prepareCodes(codesRaw)
    };
  }));
};

PLR_KEYS = [['whyThisRecommendation', ['whyThisRecommendation', 'benefitsAndHarms', 'additionalInformation']], ['whyThisGoodPracticeStatement', ['whyAGoodPracticeStatement', 'benefitsAndHarms', 'additionalInformation']], ['whatItMeansForYou', ['whatYouCanDo', 'speakWithHCProfessional']], ['whoIsThisFor', ['whoIsThisFor']]];

PLR_PARTS_WITH_ADDITIONAL_FIELDS = ['whoIsThisFor', 'speakWithHCProfessional'];

plrBasePath = function(baseKey, key) {
  return "templateData.presentations.sections.patients.sections." + baseKey + ".parts." + key;
};

plrContentPath = function(baseKey, key) {
  return "" + (plrBasePath(baseKey, key)) + ".content";
};

getPlrRecommendationText = function(recommendation, isGps) {
  var attachments, contentFromPresentations, contentFromRecommendation, key;
  attachments = get(recommendation, '_attachments', {});
  contentFromPresentations = renderEditorValue(get(recommendation, 'templateData.presentations.sections.patients.sections.recommendation.content'), attachments);
  if (!_.isEmpty(contentFromPresentations)) {
    return contentFromPresentations;
  }
  key = isGps ? 'goodPracticeStatement' : 'recommendation';
  contentFromRecommendation = renderEditorValue(get(recommendation, "templateData.conclusions.sections." + key + ".content"), attachments);
  if (_.isEmpty(contentFromRecommendation)) {
    return;
  }
  return contentFromRecommendation;
};

getAdditionalParts = function(recommendation, baseKey, key) {
  var additionalParts, parts;
  additionalParts = get(recommendation, "" + (plrBasePath(baseKey, key)) + ".additionalFields");
  if (!additionalParts) {
    return;
  }
  parts = _.chain(additionalParts).map(function(part) {
    var content;
    content = get(part, 'content');
    if (!content) {
      return null;
    }
    return content.trim();
  }).compact().value();
  if (!parts.length) {
    return;
  }
  return parts;
};

exportPlr = function(recommendation, isGps) {
  var attachments, plrData, plrRecommendation, presentationName;
  if (!recommendation) {
    return;
  }
  attachments = get(recommendation, '_attachments', {});
  plrRecommendation = getPlrRecommendationText(recommendation, isGps);
  if (!plrRecommendation) {
    return;
  }
  presentationName = get(recommendation, 'templateData.presentations.sections.patients.presentationName');
  plrData = _.chain(PLR_KEYS).map(function(_arg) {
    var baseKey, keys;
    baseKey = _arg[0], keys = _arg[1];
    if (isGps && baseKey === 'whyThisRecommendation') {
      return;
    }
    if (!isGps && baseKey === 'whyThisGoodPracticeStatement') {
      return;
    }
    return _.map(keys, function(key) {
      var additionalParts, content;
      content = renderEditorValue(get(recommendation, plrContentPath(baseKey, key)), attachments);
      additionalParts = __indexOf.call(PLR_PARTS_WITH_ADDITIONAL_FIELDS, key) >= 0 ? getAdditionalParts(recommendation, baseKey, key) : void 0;
      if (_.isEmpty(additionalParts) && _.isEmpty(content)) {
        return;
      }
      return [
        key, {
          additionalParts: additionalParts,
          content: content
        }
      ];
    });
  }).compact().flatten(true).compact().object().extend({
    presentationName: presentationName
  }).value();
  return {
    plrRecommendation: plrRecommendation,
    plrData: plrData
  };
};

module.exports = {
  calculateTrustworthiness: calculateTrustworthiness,
  convertMaybeDraftJsToPlainText: convertMaybeDraftJsToPlainText,
  exportAgreeScore: exportAgreeScore,
  exportAndSplitBySemicolon: exportAndSplitBySemicolon,
  exportAssessmentSummary: exportAssessmentSummary,
  exportBooleanWithAdditionalOptions: exportBooleanWithAdditionalOptions,
  exportCodeField: exportCodeField,
  exportCodes: exportCodes,
  exportConclusions: exportConclusions,
  exportFieldWithMissing: exportFieldWithMissing,
  exportGuidelineFields: exportGuidelineFields,
  exportIsof: exportIsof,
  exportJustification: exportJustification,
  exportJustificationPromise: exportJustificationPromise,
  exportPlr: exportPlr,
  exportYesNoTextField: exportYesNoTextField,
  getAssessmentSectionsPromises: getAssessmentSectionsPromises,
  getCertaintyOfEvidenceAndLabel: getCertaintyOfEvidenceAndLabel,
  getCertaintyOfEvidenceCircles: getCertaintyOfEvidenceCircles,
  getConclusionsContentPromise: getConclusionsContentPromise,
  getEtdPrintout: getEtdPrintout,
  getQuestionSectionsContentPromise: getQuestionSectionsContentPromise,
  getRecommendationDirectionAndStrength: getRecommendationDirectionAndStrength,
  getRecommendationHeaderData: getRecommendationHeaderData,
  getRecommendationMetadata: getRecommendationMetadata,
  getRecommendationMetadataOrUndefined: getRecommendationMetadataOrUndefined,
  getRecommendationText: getRecommendationText,
  getRecommendationTextContent: getRecommendationTextContent,
  getRemarks: getRemarks,
  getRemarksContent: getRemarksContent,
  getRemarksText: getRemarksText,
  getSimplifiedGradeCertaintyOfEvidence: getSimplifiedGradeCertaintyOfEvidence,
  getSofPrintout: getSofPrintout,
  gradeProCodeToWHOCode: gradeProCodeToWHOCode,
  prepareCodes: prepareCodes,
  renderEditorValue: renderEditorValue,
  renderEditorValueFromRecommendationMetadata: renderEditorValueFromRecommendationMetadata
};
